import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FileDTO } from '../../../dtos/file.dto';
import { UploadType } from '../../../enums/upload-type.enum';
import { LMSCourseService } from '../../../services/lms-courses/lms-course.service';
import { UploadStyles } from '../../file-management/file-upload/file-upload.component';
import { ModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'app-lms-course-create-modal',
  standalone: false,
  templateUrl: './lms-course-create-modal.component.html',
  styleUrl: './lms-course-create-modal.component.scss',
})
export class LmsCourseCreateModalComponent implements OnDestroy, AfterViewInit {
  @ViewChild('modal') modal: ModalComponent;

  @Output() readonly modalReset = new EventEmitter();

  @Output() readonly courseCreated = new EventEmitter();

  subs: Subscription[] = [];

  isLoading: boolean;

  courseFile: string | null = null;

  courseFileShort: string | undefined;

  uploadStyle = UploadStyles.SIMPLE;

  uploadType = UploadType.USER_UPLOAD;

  errorMessage: string | null = null;

  constructor(private CourseService: LMSCourseService) {}

  ngAfterViewInit(): void {
    this.modal.open();
  }

  createCourse() {
    if (this.courseFile) {
      this.isLoading = true;
      this.CourseService.createCourse(this.courseFile).subscribe((res) => {
        this.isLoading = false;
        if (res.error) {
          this.errorMessage = res.error;
        }
        if (res.item) {
          this.courseCreated.emit(res.item.id);
          this.resetModal();
        }
      });
    }
  }

  // UPLOAD
  updateCourseFile(file: FileDTO) {
    this.courseFile = file.location;
    this.courseFileShort = file.location.split('/').pop();
  }

  deleteCourseFile() {
    this.courseFile = null;
    this.courseFileShort = undefined;
    this.errorMessage = null;
  }

  resetModal() {
    this.errorMessage = null;
    this.courseFile = null;
    this.courseFileShort = undefined;
    this.modalReset.emit();
  }

  ngOnDestroy(): void {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }

    if (this.modal) {
      this.modal.close();
    }
    this.modalReset.emit();
  }
}
